import { useState } from "react";
import { Alert, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import ArchiveDocumentList from "@/components/DocumentList/ArchiveDocumentList";
// TODO: remove style cross-dependency
import "@/screens/DocumentList.scss";

export default function ArchiveListScreen() {
  const [error] = useState("");

  return (
    <Container className="page-container">
      {error && <Alert variant="danger">{error}</Alert>}
      <p>
        <Link to="/documents">Documents</Link> {">"} Archived
      </p>
      <header className="d-flex justify-content-between mb-3">
        <h1>Archived Document List</h1>
      </header>
      <div>
        <ArchiveDocumentList />
      </div>
    </Container>
  );
}
